import Media from './Media.vue';
import MediaList from './MediaList.vue';
export default {
  Media,
  MediaList,
};
